
import Vue from 'vue'
import moment from 'moment'
import {Component, Watch} from 'vue-property-decorator'
import {State, Getter, Mutation, Action, namespace} from 'vuex-class'
import {optionsVslim} from '@/config/v-slim-dialog'
import SelectConseiller from '@/components/common/SelectConseiller.vue'
import UiIcon from '@/components/common/UiIcon.vue'
import PageLayout from '@/layouts/Page.vue'
import {currentConseillerId} from '@/helpers'

const authModule = namespace('auth')
const alerteModule = namespace('alerte')
const prospectModule = namespace('prospect')
const echangeModule = namespace('echange')
const propositionModule = namespace('proposition')
const essaiModule = namespace('essai')

@Component({
  components: {
    SelectConseiller,
    UiIcon,
    PageLayout
  }
})
export default class Dashboard extends Vue {
  @authModule.Getter('meGetter') me: any
  @alerteModule.Action('getAlertesByIdConseillerAction') getAlertesByIdConseiller: any
  @alerteModule.Action('deleteAlerteAction') deleteAlerte: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @prospectModule.Action('getProspectsCountAction') getProspectsCount: any
  @prospectModule.Action('getProspectsEnCoursCountAction') getProspectsEnCoursCount: any
  @prospectModule.Action('getProspectsEnCoursCountByConseillerAction') getProspectsEnCoursCountByConseiller: any
  @prospectModule.Action('getProspectsPropositionEnCoursCountAction') getProspectsPropositionEnCoursCount: any
  @prospectModule.Action('getProspectsPropositionEnCoursCountByConseillerAction')
  getProspectsPropositionEnCoursCountByConseiller: any

  @prospectModule.Action('getProspectsEssaiEnCoursCountAction') getProspectsEssaiEnCoursCount: any
  @prospectModule.Action('getProspectsEssaiEnCoursCountByConseillerAction')
  getProspectsEssaiEnCoursCountByConseillerAction: any

  @prospectModule.Action('getProspectsNouvelEchangeATraiterCountAction') getProspectsNouvelEchangeATraiterCount: any
  @prospectModule.Action('getProspectsNouvelEchangeATraiterCountByConseillerAction')
  getProspectsNouvelEchangeATraiterCountByConseiller: any

  @prospectModule.Action('getProspectsNonAffectesCountAction') getProspectsNonAffectesCount: any
  @prospectModule.Action('getProspectsPropositionAFaireCountAction') getProspectsPropositionAFaireCount: any
  @prospectModule.Action('getProspectsARelancerCountAction') getProspectsARelancerCount: any
  @prospectModule.Action('getProspectsEntrantsCountAction') getProspectsEntrantsCount: any
  @echangeModule.Action('getEchangesCountAction') getEchangesCount: any
  @propositionModule.Action('getPropositionsCountAction') getPropositionsCount: any
  @essaiModule.Action('getEssaisCountAction') getEssaisCount: any
  @alerteModule.Getter('alertesGetter') alertes: any

  prospectsCount = null
  prospectsCountTotal = null
  prospectsPropositionCount = null
  prospectsPropositionCountTotal = null
  prospectsEssaiCount = null
  prospectsEssaiCountTotal = null
  prospectsNonAffectesCount = null
  prospectsPropositionAFaireCount = null
  prospectsARelancerCount = null
  prospectsEntrantsCount = null
  prospectsNouvelEchangeATraiterCount = null

  panel = null

  alerteConseillerId = currentConseillerId()

  get activityCards() {
    return [
      {
        key: 'prospects',
        label: 'Prospects en cours',
        icon: 'users',
        tone: 'teal',
        count: this.prospectsCount,
        total: this.prospectsCountTotal
      },
      {
        key: 'propositions',
        label: 'Propositions en cours',
        icon: 'send',
        tone: 'blue',
        count: this.prospectsPropositionCount,
        total: this.prospectsPropositionCountTotal
      },
      {
        key: 'essais',
        label: 'Essais en cours',
        icon: 'spark',
        tone: 'violet',
        count: this.prospectsEssaiCount,
        total: this.prospectsEssaiCountTotal
      }
    ]
  }

  get priorityCards() {
    return [
      {
        key: 'unassigned',
        label: 'Non affectés',
        description: 'Prospects sans conseiller',
        icon: 'users',
        tone: 'slate',
        count: this.prospectsNonAffectesCount,
        query: {conseiller: 0, action: 'filtre'}
      },
      {
        key: 'messages',
        label: 'Échanges à traiter',
        description: 'Conversations à reprendre',
        icon: 'message',
        tone: 'blue',
        count: this.prospectsNouvelEchangeATraiterCount,
        query: {
          conseiller: this.alerteConseillerId,
          nouvelEchangeATraiter: true,
          refStatuts: ['E', 'N', 'Q', 'R', 'CS', 'E2', 'MQ'],
          action: 'filtre'
        }
      },
      {
        key: 'followup',
        label: 'À relancer',
        description: 'Propositions à suivre',
        icon: 'clock',
        tone: 'amber',
        count: this.prospectsARelancerCount,
        query: {
          conseiller: this.alerteConseillerId,
          refStatuts: ['N'],
          propositionEnCours: '1',
          dateEchangeMax: this.getRelanceDate(),
          action: 'filtre'
        }
      },
      {
        key: 'incoming',
        label: 'Nouveaux entrants',
        description: 'Premiers contacts à découvrir',
        icon: 'inbox',
        tone: 'teal',
        count: this.prospectsEntrantsCount,
        query: {refStatuts: ['E'], action: 'filtre', conseiller: ''}
      }
    ]
  }

  formatCount(value) {
    return value === null || value === undefined ? '—' : Number(value).toLocaleString('fr-FR')
  }

  @Watch('me', {deep: false})
  watchMe(val: any) {
    if (val) {
      this.alerteConseillerId = val.ID
      this.getAlertesByIdConseiller(val.ID)
      this.getProspectsEnCoursCountByConseiller(val.ID).then((data) => {
        this.prospectsCount = data.count
      })
      this.getProspectsPropositionEnCoursCountByConseiller(val.ID).then((data) => {
        this.prospectsPropositionCount = data.count
      })
      this.getProspectsEssaiEnCoursCountByConseillerAction(val.ID).then((data) => {
        this.prospectsEssaiCount = data.count
      })
      this.getProspectsNouvelEchangeATraiterCountByConseiller(val.ID).then((data) => {
        this.prospectsNouvelEchangeATraiterCount = data.count
      })
      this.getProspectsPropositionAFaireCount(val.ID).then((data) => {
        this.prospectsPropositionAFaireCount = data.count
      })

      this.getProspectsARelancerCount(val.ID).then((data) => {
        this.prospectsARelancerCount = data.count
      })
    }
  }

  @Watch('alerteConseillerId', {deep: false})
  watchAlerteConseillerId(val: any) {
    this.getAlertesByIdConseiller(val)
  }

  getClassForIndicator(date) {
    return moment(date).isBefore(moment()) ? 'bg-red' : 'bg-green'
  }

  getHumanDate(date) {
    return moment(date).locale('fr').fromNow()
  }

  getRelanceDate() {
    return moment().subtract(10, 'd').format('DD/MM/YYYY')
  }

  mounted() {
    if (this.me) {
      this.getAlertesByIdConseiller(this.me.ID)
      this.getProspectsEnCoursCountByConseiller(this.me.ID).then((data) => {
        this.prospectsCount = data.count
      })
      this.getProspectsPropositionEnCoursCountByConseiller(this.me.ID).then((data) => {
        this.prospectsPropositionCount = data.count
      })
      this.getProspectsEssaiEnCoursCountByConseillerAction(this.me.ID).then((data) => {
        this.prospectsEssaiCount = data.count
      })
      this.getProspectsNouvelEchangeATraiterCountByConseiller(this.me.ID).then((data) => {
        this.prospectsNouvelEchangeATraiterCount = data.count
      })
      this.getProspectsPropositionAFaireCount(this.me.ID).then((data) => {
        this.prospectsPropositionAFaireCount = data.count
      })

      this.getProspectsARelancerCount(this.me.ID).then((data) => {
        this.prospectsARelancerCount = data.count
      })
    }
    this.getProspectsEnCoursCount().then((data) => {
      this.prospectsCountTotal = data.count
    })

    this.getProspectsPropositionEnCoursCount().then((data) => {
      this.prospectsPropositionCountTotal = data.count
    })

    this.getProspectsEssaiEnCoursCount().then((data) => {
      this.prospectsEssaiCountTotal = data.count
    })

    this.getProspectsNonAffectesCount().then((data) => {
      this.prospectsNonAffectesCount = data.count
    })

    this.getProspectsEntrantsCount().then((data) => {
      this.prospectsEntrantsCount = data.count
    })
  }

  beforeDestroy() {
    if (this.panel) this.panel.hide()
  }

  previewHandler(id: number) {
    this.getProspectById(id).then((data: any) => {
      this.panel = this.$showPanel({
        component: 'prospectPanel',
        openOn: 'right',
        width: 400,
        keepAlive: false,
        props: {
          data
        }
      })
    })
  }

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm("Confirmez vous la suppression de l'alerte ?", optionsVslim)
    if (ok) {
      this.deleteAlerte(id).then(async () => {
        await this.getAlertesByIdConseiller(this.me.ID)
      })
    }
  }
}
